// assets/pdp-oos-variant-select.js
(function () {
  function convert(el) {
    if (el.matches && el.matches('input.product__variant--button[disabled]')) {
      el.disabled = false;
      const label = document.querySelector('label[for="' + el.id + '"]');
      if (label) {
        label.classList.remove('sold-out');
        label.classList.add('sold-out-selectable');
        const strike = label.querySelector(':scope > div.absolute.inset-0');
        if (strike) strike.remove();
      }
      return;
    }
    if (el.tagName === 'OPTION' && el.disabled) {
      el.disabled = false;
    }
  }

  function unlock(root) {
    root.querySelectorAll('input.product__variant--button[disabled], option[disabled]').forEach(convert);

    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === 'attributes') {
          convert(m.target);
          return;
        }
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          // Defensively clean up strike-through divs re-added by enavi-custom.js's colorObserver
          if (node.matches && node.matches('div.absolute.inset-0')) {
            const label = node.closest('label.sold-out-selectable');
            if (label) node.remove();
          }
          convert(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('input.product__variant--button[disabled], option[disabled]').forEach(convert);
          }
        });
      });
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  document.querySelectorAll('variant-button, variant-select').forEach(unlock);
})();

(function () {
  // Appikon injects #SI_trigger into the DOM asynchronously (see their own
  // window.deferBisProductPageButton polling helper). On initial page load
  // our first updateNotify() call can run before #SI_trigger exists, so it
  // silently no-ops and nothing retries it. Mirror Appikon's own poll
  // interval so the initial call waits for the trigger to actually exist.
  function waitForTrigger(cb, attempts) {
    attempts = attempts || 0;
    if (document.getElementById('SI_trigger')) {
      cb();
      return;
    }
    if (attempts > 100) return; // ~5s at 50ms; give up quietly if Appikon never injects it
    setTimeout(function () {
      waitForTrigger(cb, attempts + 1);
    }, 50);
  }

  // app.js only sets root.currentVariant when it resolves checked radio
  // inputs against the variant list. Single-variant "Default Title"
  // products (e.g. castleair-eu) render zero fieldsets/inputs, so
  // app.js's resolution logic never runs and currentVariant stays
  // undefined forever. Fall back to the data-variant/js-variants
  // attributes Liquid always sets on variant-button (see
  // snippets/variant-button.liquid:80-87), which don't depend on any
  // picker UI existing. variant-select has data-variant but not
  // js-variants; the guard below returns null for that case, same as
  // today's behavior.
  function resolveCurrentVariant(root) {
    if (root.currentVariant) return root.currentVariant;

    const dataVariant = root.getAttribute('data-variant');
    const rawVariants = root.getAttribute('js-variants');
    if (!dataVariant || !rawVariants) return null;

    try {
      const variants = JSON.parse(
        rawVariants.replace(/'/g, '"').replace(/,\s*]/g, ']').replace(/,\s*}/g, '}')
      );
      return variants.find((v) => String(v.id) === String(dataVariant)) || null;
    } catch (e) {
      return null;
    }
  }

  // #SI_trigger is no longer hidden by default via CSS (see enavi-custom.css) —
  // it keeps whatever display state Appikon's own script last set unless we
  // explicitly take control here. Setting the inline style directly (not via
  // a class-driven cascade rule) guarantees our decision wins over Appikon's
  // own inline style on the same element, regardless of ordering.
  function setTriggerVisible(trigger, visible) {
    trigger.classList.toggle('oos-notify-visible', visible);
    trigger.style.setProperty('display', visible ? 'block' : 'none', 'important');
  }

  function updateNotify(root, currentVariant) {
    const trigger = document.getElementById('SI_trigger');
    if (!trigger) return;

    if (!currentVariant) {
      setTriggerVisible(trigger, false);
      return;
    }

    const form = document.querySelector('form.shopify-product-form');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    if (idInput) idInput.value = currentVariant.id;

    if (currentVariant.available === false) {
      setTriggerVisible(trigger, true);
      try {
        if (window.SIPopover && typeof window.SIPopover.variantChanged === 'function') {
          window.SIPopover.variantChanged();
        }
      } catch (e) {
        // Best-effort only. If this hook is missing or errors (e.g. Appikon
        // changes their script), Appikon's popover still opens with its own
        // default variant selection — nothing else in this file depends on
        // this succeeding.
      }
    } else {
      setTriggerVisible(trigger, false);
    }
  }

  document.querySelectorAll('variant-button, variant-select').forEach((root) => {
    waitForTrigger(() => updateNotify(root, resolveCurrentVariant(root)));
    root.addEventListener('change', () => updateNotify(root, root.currentVariant));
  });
})();
